// extracted by mini-css-extract-plugin
export var externalLink = "_64-0";
export var internalLinkLabel = "_64-1";